const apiStates = {
  INIT: 0,
  LOADING: 1,
  ERROR: 2,
  LOADED: 3
}

export default apiStates
